import { FaIcon } from "lib/FaIcon";
import { toArray } from "lib/utils";
import { push, removeParam, gotoSearchResultsPage } from "pages/search/api/filterUrlMaker";
import { formatPillDate, isDateCategory } from "pages/search/searchBar/formatPillDate";
import { Pill } from "pages/search/searchBar/Pill";
import "./Pills.scss";

export function PillsFromFilter(filter) {
  return Object.entries(filter)
    .map(([category, option]) => [category, toArray(option)])
    .map(([category, options]) => options.map((option) => ({ category, text: option })))
    .flat()
    .filter((pill) => !isExcluded(pill.category))
    .filter((pill) => pill.text);
}

export function Pills({ pills, persistent }) {
  return pills.map(({ text, category }, key) => {
    if (isDateCategory(category)) text = formatPillDate(text, category);

    // TODO: If we need dynamic colored pills
    // const finalVariant = persistent ? "primary" : "info";
    // const originalVariant = "info";
    const finalCursor = persistent ? "normal" : "cursor-pointer";
    const finalIcon = !persistent ? "fa fa-times ml-1" : "";

    return (
      <Pill
        key={key + text}
        text={text === "SP__Credit" ? "SP/Credit" : text}
        isActive={true}
        variant="info"
        onClick={() => (category === "route" ? gotoSearchResultsPage() : push(removeParam(category, text)))}
        icon={finalIcon}
        cursor={finalCursor}
      />
    );
  });
}

export const isExcluded = (category) =>
  ["sort", "SortAsc", "SortDesc", "From", "language", "includeSynopsis", "groupBy", "alt"].includes(category);

export const X = () => <FaIcon icon="fa fa-times ml-1" align="" />;
